module.exports = __webpack_public_path__ + "static/media/051.1bf92b47.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/normals/051.jpg
// module id = 346
// module chunks = 0